import { render, staticRenderFns } from "./monacoEditor.vue?vue&type=template&id=a06692c8&scoped=true"
import script from "./monacoEditor.vue?vue&type=script&lang=js"
export * from "./monacoEditor.vue?vue&type=script&lang=js"
import style0 from "./monacoEditor.vue?vue&type=style&index=0&id=a06692c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06692c8",
  null
  
)

export default component.exports